import { css } from '@emotion/react'
import styled from '@emotion/styled'

const contentStyles = ({ theme }) => css`
  label: content;

  overflow-y: auto;

  padding-right: ${theme.spacings.byte};
  margin-right: ${theme.spacings.bit};
`

const fixedHeightContentStyles = ({ fixedHeight }) =>
  fixedHeight &&
  css`
    label: content--fixed-height;

    max-height: 128px;
  `

export const Content = styled('div')(contentStyles, fixedHeightContentStyles)
